<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content">
            <div class="card card-body">
                <div class="form-group">
                    <v-select
                        :options="filtered_cardseries"
                        :get-option-label="(opt) => (opt.disabled ? opt.SeriesName : opt.CardSeriesID + ': ' + opt.SeriesName)"
                        placeholder="Välj kortserie..."
                        :reduce="(opt) => opt.CardSeriesID"
                        :selectable="(opt) => !opt.disabled"
                        @input="selected"
                    ></v-select>
                </div>
                <div class="form-group">
                    <div class="custom-control custom-checkbox custom-control-inline mt-2">
                        <input id="chk-show-all" type="checkbox" class="custom-control-input" v-model="show_all">
                        <label for="chk-show-all" class="custom-control-label">Visa alla</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import vSelect from 'vue-select';
import apiClient from '@services/ApiClient';

export default {
    name: 'ProductRange',
    components: {
        LimitlessPageHeader,
        vSelect,
    },
    data: () => ({
        show_all: false,
        cardseries: [],
    }),
    mounted() {
        this.getCardSeries();
    },
    methods: {
        getCardSeries() {
            apiClient.get('/vue/cardseries?show_hidden=1&only_series=1&per_page=10000')
                .then((response) => {
                    this.cardseries = response.data.data;
                });
        },
        selected(id) {
            this.$router.push({
                name: 'productrange.edit',
                params: {
                    cardSerieId: id,
                },
            });
        },
    },
    computed: {
        filtered_cardseries() {
            const arr = this.cardseries.filter((serie) => !!(this.show_all || serie.isForSale));
            arr.unshift({ CardSeriesID: 0, SeriesName: '----------------------------', disabled: true });
            arr.unshift({ CardSeriesID: 0, SeriesName: 'ÖVERSKOTTSPRODUKTER' });
            return arr;
        },
    },
};
</script>
